import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import {
  tochiAnimationReducer,
  TochiAnimationReduxType,
} from "./tochiAnimation";
import { tochiAssetReducer, TochiAssetReduxType } from "./tochiAsset";
import { tochiChickenReducer, TochiChickenReduxType } from "./tochiChicken";

export interface StoreState {
  tochiAnimation: TochiAnimationReduxType;
  tochiAsset: TochiAssetReduxType;
  tochiChicken: TochiChickenReduxType;
}

export const reducers = combineReducers<StoreState>({
  tochiAnimation: tochiAnimationReducer,
  tochiAsset: tochiAssetReducer,
  tochiChicken: tochiChickenReducer,
});

export const store = configureStore({
  reducer: reducers,
});
